/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var OffsetLinkStatus;
(function (OffsetLinkStatus) {
    OffsetLinkStatus["ENABLED"] = "enabled";
    OffsetLinkStatus["DISABLED"] = "disabled";
})(OffsetLinkStatus || (OffsetLinkStatus = {}));
//# sourceMappingURL=OffsetLinkStatus.js.map